"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ProductSelection = exports.SuiteDescription = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var person_1 = __importDefault(require("@atlaskit/icon/glyph/person"));
var people_group_1 = __importDefault(require("@atlaskit/icon/glyph/people-group"));
var office_building_1 = __importDefault(require("@atlaskit/icon/glyph/office-building"));
var addon_1 = __importDefault(require("@atlaskit/icon/glyph/addon"));
var tooltip_1 = __importDefault(require("@atlaskit/tooltip"));
var powerUpsData_1 = require("./powerUpsData");
var react_1 = require("react");
var trello_1 = require("@powerupsclub/trello");
var open_1 = __importDefault(require("@atlaskit/icon/glyph/open"));
var prices_1 = require("../../../prices");
var Product = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, isSelected = _a.isSelected, description = _a.description, onClick = _a.onClick, icon = _a.icon, disabled = _a.disabled, isAdvancedBilling = _a.isAdvancedBilling, children = _a.children;
    var trelloIframe = (0, react_1.useContext)(trello_1.TrelloPowerUpContext).trelloIframe;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ onClick: disabled ? undefined : onClick, style: {
            borderRadius: '5px',
            border: "2px solid ".concat(isSelected
                ? trelloIframe.getComputedColorToken('color.border.selected', '#0570de')
                : trelloIframe.getComputedColorToken('color.border', '#e6e6e6')),
            padding: '12px',
            color: isSelected
                ? trelloIframe.getComputedColorToken('color.text.selected', '#0570de')
                : isAdvancedBilling
                    ? trelloIframe.getComputedColorToken('color.text', 'black')
                    : trelloIframe.getComputedColorToken('color.text', 'black'),
            cursor: isSelected || disabled ? 'default' : 'pointer'
        } }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ style: {
                    fontWeight: 500,
                    fontSize: '15px',
                    display: 'flex',
                    gap: '6px',
                    alignItems: 'center'
                } }, { children: [icon, title, isAdvancedBilling && (0, jsx_runtime_1.jsx)(open_1["default"], { label: "Open", size: "small" }, void 0)] }), void 0), (0, jsx_runtime_1.jsx)("div", __assign({ style: {
                    fontSize: '14px',
                    paddingTop: '8px',
                    color: trelloIframe.getComputedColorToken('color.text', 'black')
                } }, { children: subtitle }), void 0), (0, jsx_runtime_1.jsx)("div", __assign({ style: {
                    fontSize: '14px',
                    color: trelloIframe.getComputedColorToken('color.text', 'black'),
                    marginTop: '12px'
                } }, { children: description }), void 0), isSelected && children] }), void 0));
};
function SuiteDescription(_a) {
    var description = _a.description;
    var trelloIframe = (0, react_1.useContext)(trello_1.TrelloPowerUpContext).trelloIframe;
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", __assign({ style: {
                    fontSize: '14px',
                    color: trelloIframe.getComputedColorToken('color.text', 'black'),
                    marginTop: '12px'
                } }, { children: description }), void 0), (0, jsx_runtime_1.jsx)("div", __assign({ style: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '12px 8px',
                    padding: '12px'
                } }, { children: powerUpsData_1.POWER_UPS_DATA.map(function (powerUp) { return ((0, jsx_runtime_1.jsx)(tooltip_1["default"], __assign({ content: powerUp.description }, { children: (0, jsx_runtime_1.jsxs)("a", __assign({ href: powerUp.url, target: "_blank", style: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '6px',
                            width: '80px',
                            textAlign: 'center',
                            cursor: 'pointer',
                            textDecoration: 'none'
                        } }, { children: [(0, jsx_runtime_1.jsx)("img", { style: { width: '50px', height: '50px' }, src: "https://tinypowerups.com/".concat(powerUp.image) }, void 0), (0, jsx_runtime_1.jsx)("div", __assign({ style: {
                                    fontSize: '12px',
                                    color: trelloIframe.getComputedColorToken('color.text', 'black')
                                } }, { children: powerUp.name }), void 0)] }), void 0) }), powerUp.idPlugin)); }) }), void 0)] }, void 0));
}
exports.SuiteDescription = SuiteDescription;
var ProductSelection = function (_a) {
    var selectedProduct = _a.selectedProduct, onProductChange = _a.onProductChange, disableWorkspaceLicense = _a.disableWorkspaceLicense;
    var _b = (0, react_1.useContext)(trello_1.TrelloPowerUpContext), trelloIframe = _b.trelloIframe, appName = _b.appName, powerUpKey = _b.powerUpKey;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ style: { display: 'flex', flexDirection: 'column', gap: '12px' } }, { children: [(0, jsx_runtime_1.jsx)(Product, __assign({ disabled: disableWorkspaceLicense, onClick: function () { return onProductChange('workspace'); }, title: trelloIframe.localizeKey('workspace-license'), subtitle: trelloIframe.localizeKey('9.99-pypn-100pupy'), isSelected: selectedProduct === 'workspace', icon: (0, jsx_runtime_1.jsx)(people_group_1["default"], { label: "group" }, void 0) }, { children: (0, jsx_runtime_1.jsx)(SuiteDescription, { description: trelloIframe.localizeKey('workspace-desc') }, void 0) }), void 0), (0, jsx_runtime_1.jsx)(Product, __assign({ onClick: function () { return onProductChange('individual'); }, title: trelloIframe.localizeKey('individual-license'), subtitle: trelloIframe.localizeKey('9.99pm-100py'), isSelected: selectedProduct === 'individual', icon: (0, jsx_runtime_1.jsx)(person_1["default"], { label: "person" }, void 0) }, { children: (0, jsx_runtime_1.jsx)(SuiteDescription, { description: trelloIframe.localizeKey('individual-desc') }, void 0) }), void 0), (0, jsx_runtime_1.jsx)(Product, { disabled: disableWorkspaceLicense, onClick: function () { return onProductChange('powerup'); }, title: trelloIframe.localizeKey('powerup-license', {
                    powerUpName: appName
                }), subtitle: trelloIframe.localizeKey('pypn-pupy', {
                    monthlyRate: prices_1.prices[powerUpKey].monthly,
                    yearlyRate: prices_1.prices[powerUpKey].yearly
                }), isSelected: selectedProduct === 'powerup', icon: (0, jsx_runtime_1.jsx)(addon_1["default"], { label: "powerup" }, void 0) }, void 0), (0, jsx_runtime_1.jsx)(Product, { onClick: function () {
                    window.open('https://tinypowerups.com/manage-subscription#workspaces', '_blank', 'noopener,noreferrer');
                }, title: trelloIframe.localizeKey('advanced-billing'), subtitle: trelloIframe.localizeKey('9.99-pypn-100pupy'), description: trelloIframe.localizeKey('advanced-billing-desc'), isSelected: false, icon: (0, jsx_runtime_1.jsx)(office_building_1["default"], { label: "team" }, void 0), isAdvancedBilling: true }, void 0)] }), void 0));
};
exports.ProductSelection = ProductSelection;
//# sourceMappingURL=ProductSelection.js.map